<template>
  <div class="cover-block">
    <div class="row">
      <div class="col-md-3 col-sm-3 col-xs-3">
        <BaseButton
          v-if="!file"
          theme="secondary"
          class="cover-block__load-button"
          tag="label"
          for="document"
        >
          Загрузить
        </BaseButton>
        <FilePreview v-else :file="file" class="mb-s" @clear="handleClear" />
        <p class="cover-block__picture-text">
          Фото здания или помещения кружка. Фото позволит участникам
          сориентироваться и&nbsp;быстрее найти кружок
        </p>
      </div>
      <div class="col-md-9 col-sm-9 col-xs-9">
        <div class="platform-cover">
          <div
            v-show="!isCoverFromFile"
            :style="{
              backgroundImage: preview ? `url(${preview})` : null,
            }"
            class="platform-cover__inner"
          >
            <div
              v-if="!preview"
              :style="{
                backgroundImage: baseBackgroundImage,
              }"
              class="platform-cover__inner"
            />
          </div>

          <div v-show="isCoverFromFile" class="org-logo__inner">
            <VueCropper
              ref="cropper"
              :aspect-ratio="PLATFORM_COVER_WIDTH / PLATFORM_COVER_HEIGHT"
              :initialAspectRatio="PLATFORM_COVER_WIDTH / PLATFORM_COVER_HEIGHT"
              :minContainerWidth="PLATFORM_COVER_WIDTH"
              :minContainerHeight="PLATFORM_COVER_HEIGHT"
              drag-mode="move"
              :src="preview"
              :auto-crop-area="1"
              :view-mode="2"
              :crop-box-movable="false"
              :center="false"
              :crop-box-resizable="false"
              :toggle-drag-mode-on-dblclick="false"
              :check-cross-origin="false"
              :zoom-on-wheel="false"
              class="platform-cropper"
            />
          </div>

          <button
            v-if="isCoverFromFile"
            type="button"
            class="move-arrow right"
            @click.prevent="move(10, 0)"
          >
            <BaseIcon glyph="arrow-right" />
          </button>
          <button
            v-if="isCoverFromFile"
            type="button"
            class="move-arrow left"
            @click.prevent="move(-10, 0)"
          >
            <BaseIcon glyph="arrow-right" />
          </button>
          <button
            v-if="isCoverFromFile"
            type="button"
            class="move-arrow top"
            @click.prevent="move(0, 10)"
          >
            <BaseIcon glyph="arrow-right" />
          </button>
          <button
            v-if="isCoverFromFile"
            type="button"
            class="move-arrow bottom"
            @click.prevent="move(0, -10)"
          >
            <BaseIcon glyph="arrow-right" />
          </button>

          <button
            v-if="!deleted && !file && cover"
            type="button"
            class="platform-cover__delete"
            title="Удалить изображение"
            @click="handleDelete"
          >
            <BaseIcon width="1.4em" glyph="trash" />
          </button>
        </div>
        <div>
          <div v-if="isCoverFromFile" class="mt-m mb-m">
            <div class="range-block">
              <div class="range-block__math">&minus;</div>
              <BaseRange
                :value="rangeValue"
                :max="1"
                :min="0"
                :step="0.1"
                @input="handleZoom"
              />
              <div class="range-block__math">&plus;</div>
            </div>
          </div>
          <div v-show="false">
            <input
              id="document"
              ref="fileInput"
              type="file"
              accept="image/jpeg,image/png"
              @change="handleFileChange"
            />
          </div>
        </div>

        <div v-if="errors && errors.length" class="form-error mt-s">
          {{ errors[0] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilePreview from "@/components/FilePreview";
import { PLATFORM_COVER_HEIGHT, PLATFORM_COVER_WIDTH } from "@/constants";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "PlatformCoverBlock",
  components: {
    VueCropper,
    FilePreview,
  },
  props: {
    cover: {
      type: String,
      default: "",
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      file: null,
      preview: "",
      deleted: false,
      rangeValue: 0,
    };
  },
  computed: {
    PLATFORM_COVER_WIDTH() {
      return PLATFORM_COVER_WIDTH;
    },
    PLATFORM_COVER_HEIGHT() {
      return PLATFORM_COVER_HEIGHT;
    },
    isCoverFromFile() {
      return !!this.file;
    },
    currentCover() {
      const { cover, deleted } = this;
      if (cover && !deleted) return cover;
      return null;
    },
    baseBackgroundImage() {
      return `url(${require("@/assets/images/venue-bg.jpg")})`;
    },
  },
  mounted() {
    // без задержки картинка не успевает прийти
    setTimeout(() => {
      if (this.cover) {
        this.preview = this.cover;
      }
    }, 300);
  },
  methods: {
    getPreviewImage(file) {
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.preview = e.target.result;
        this.rangeValue = 0;
        this.$refs.cropper.replace(e.target.result);
      };
      reader.readAsDataURL(file);
    },
    handleClear() {
      this.file = null;
      this.$refs.fileInput.value = "";
      this.preview = this.currentCover ? this.currentCover : "";
      this.$emit("input", null);
    },
    handleFileChange(e) {
      this.file = e.target.files;
      this.getPreviewImage(e.target.files[0]);
      this.$emit("input", e.target.files[0]);
    },
    handleDelete() {
      this.deleted = true;
      this.preview = "";
      this.$emit("deletePreview");
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    //! используется из родительского компонента
    // eslint-disable-next-line vue/no-unused-properties
    cropImage() {
      return new Promise((resolve) => {
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const file = new File([blob], "good.jpeg", {
            type: "image/jpeg",
          });
          resolve(file);
        }, "image/jpeg");
      });
    },
    handleZoom(val) {
      const zoomValue = val - this.rangeValue;
      const parsedValue = Number(zoomValue.toFixed(1));
      this.$refs.cropper.relativeZoom(parsedValue);

      this.rangeValue = val;
    },
  },
};
</script>

<style lang="less" scoped>
.platform-cover {
  width: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  aspect-ratio: @cover-aspect-ratio;
  overflow: hidden;

  &__delete {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 0;
    right: 0;
    background-color: @gray-color;
    border-radius: 50%;
    color: @dark-gray-color;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color 0.3s, background 0.3s;
    user-select: none;
    border: 0;
    padding: 0;
    outline: none;
    font-size: 12px;

    &:active {
      transform: translateY(1px);
    }

    &:hover {
      background-color: @primary-color;
      color: #fff;
    }
  }

  &::before {
    content: "";
    position: relative;
    aspect-ratio: @cover-aspect-ratio;
  }
  &__inner {
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    aspect-ratio: @cover-aspect-ratio;
  }
}

.cover-block {
  &__load-button {
    width: 100%;
    margin-bottom: 10px;
  }

  &__picture-text {
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 16/12;
    color: @dark-gray-color;
  }
}

.platform-cropper /deep/ .cropper-crop-box {
  transform: none !important;
}
.move-arrow {
  position: absolute;
  padding: 0;
  border: none;
  font: inherit;
  background-color: transparent;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: @base-color;

  &:hover {
    color: @primary-color;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #fff;
    opacity: 0.5;
    border-radius: 50%;
    z-index: -1;
  }

  &.right {
    right: 0;
    top: 50%;
    z-index: 3;
    transform: translateY(-50%);
  }
  &.left {
    left: 0;
    top: 50%;
    transform: translateY(-50%) rotate(180deg);
    z-index: 1;
  }
  &.top {
    left: 50%;
    top: 0;
    transform: translateX(-50%) rotate(-90deg);
    z-index: 1;
  }
  &.bottom {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%) rotate(90deg);
    z-index: 1;
  }
}
.range-block {
  display: flex;
  gap: 10px;
  position: relative;
  width: 100%;
  &__math {
    font-size: 24px;
    line-height: 1;
    margin-top: 1px;
  }
}
</style>
